import { render, staticRenderFns } from "./custom-rate.vue?vue&type=template&id=22da07a7&scoped=true&"
import script from "./custom-rate.vue?vue&type=script&lang=js&"
export * from "./custom-rate.vue?vue&type=script&lang=js&"
import style0 from "./custom-rate.vue?vue&type=style&index=0&id=22da07a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22da07a7",
  null
  
)

export default component.exports